export default "__VITE_ASSET__qqXzS9e4__"